import React, { cloneElement } from 'react'
import { Avatar } from 'components/ui'
import Logo from 'components/template/Logo'
import { APP_NAME } from 'constants/app.constant'

const SideOb = ({ children, content, ...rest }) => {
    return (
        <div className="grid lg:grid-cols-3 flex-1">
            <div
                className="bg-no-repeat bg-cover py-6 px-16 flex-col justify-between hidden lg:flex"
                style={{
                    backgroundImage: `url('${process.env.PUBLIC_URL}/img/others/auth-side-bg.jpg')`,
                }}
            >
                <Logo mode="dark" logoWidth={240} imgClass='w-[160px]' />
                <div>
                    
                </div>
                <span className="text-black">
                    Copyright &copy; {`${new Date().getFullYear()}`}{' '}
                    <span className="font-semibold">{`${APP_NAME}`}</span>{' '}
                </span>
            </div>
            <div className="col-span-2 flex flex-col justify-start items-start  bg-white dark:bg-gray-800">
                <div className="xl:min-w-[450px] px-8 flex-1 ">
                    <div className="mb-8">{content}</div>
                    {children ? cloneElement(children, { ...rest }) : null}
                </div>
            </div>
        </div>
    )
}

export default SideOb
